export default "__VITE_ASSET__ElfHacrR__"